// src/App.jsx
import React from 'react';
import './styles/tailwind.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ScrollProvider } from './contexts/ScrollContext';
import GlobalStyle from './styles/global';

// Import pages
import HomePage from './pages/HomePage';
import Privacy from './pages/Privacy';
import ResumeAccess from './pages/ResumeAccess';
import Resume from './components/Resume/Resume';

// Import common components
import RedesignedNavigation from './components/Navigation/RedesignedNavigation';
import RedesignedFooter from './components/Footer/RedesignedFooter';
import ScrollbarWrapper from './components/CustomScrollbar/ScrollbarWrapper';
import AnimatedBackground from './components/AnimatedBackground/AnimatedBackground';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import ThemeConfigurator from './components/ThemeConfigurator/ThemeConfigurator';

// Import Easter Eggs
import CursorEasterEgg from './components/EasterEggs/CursorEasterEgg';

// Global styles to prevent scrollbar issues
import { createGlobalStyle } from 'styled-components';

const PreventScrollbarJump = createGlobalStyle`
  html {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
  }
  
  html::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
  
  body {
    overflow-x: hidden;
  }
`;

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <ScrollProvider>
          <Router>
            <GlobalStyle />
            <PreventScrollbarJump />
            <ScrollToTop />
            {/* Add the Easter Eggs here */}
            <CursorEasterEgg />
            <ScrollbarWrapper>
              <AnimatedBackground />
              <RedesignedNavigation />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/resume" element={<ResumeAccess />} />
                <Route path="/resume/view" element={<Resume />} />
              </Routes>
              <RedesignedFooter />
            </ScrollbarWrapper>
            {/* Add ThemeConfigurator outside ScrollbarWrapper to ensure proper layering */}
            <ThemeConfigurator />
          </Router>
        </ScrollProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;